import React, { useEffect, useState } from 'react'
import { Dialog, Typography, Grid, Box, styled,useTheme
} from '@mui/material'
import { CustomCounterAppBar } from './'
//import { mainStyles } from '../styles/Main'

const ContainerPrincipal = styled(Grid)(({ theme }) => ({
    margin: "0px 45px 0px 0px",
    display: 'grid !important',
    gridTemplateColumns: '20% 60% 20%',
    gridAutoRows: '100vh !important',
    overflowY: 'hidden !important',
    '&::-webkit-scrollbar': {
        width: '0',
        background: 'transparent',
    },
    // minHeight: "100vh",
    overflowX: 'hidden',
    position: 'fixed',
    top: 0,
    bottom: 0,
    width: '100%',
    // border: '1px solid red !important',
    [theme.breakpoints.down('sm')]: {
        gridTemplateColumns: '100%',
    },
    [theme.breakpoints.up('sm')]: {
        gridTemplateColumns: '15% 70% 15%',
    },
    [theme.breakpoints.up('md')]: {
        gridTemplateColumns: '20% 60% 20%',
    },
}));

const RootStyle = styled(Box)(({ theme }) => ({
    backgroundColor: "#FFFFFF",
    width: "100%",
    minHeight: "calc(100vh - 120px)",
    margin: "0px auto",
    position: "relative",
    display: "flex",
    flexDirection: "column",
    // border: '2px solid green !important',
    maxHeight: '100vh',
}));
const OutletWrapper = styled(Box)(({ theme }) => ({
    background: "#FFFFFF",
    margin: "0px",
    marginBottom: '0px',
    minHeight: "calc(100vh - 150px)",
    overflowY: 'auto !important',
    // border: '3px solid pink !important',
    maxHeight: '85vh',
}));

const OutletCenter = styled(Box)(({ isFullScreen, theme }) => ({
    background: "#FFFFFF",
    margin: "16px 7rem",
    marginBottom: '1px',
    display: 'flex',
    flexDirection: 'column',
    // border: '5px solid purple !important',
    [theme.breakpoints.down('sm')]: {
        margin: "16px 24px",
        marginBottom: '1px',
    },
    [theme.breakpoints.up('sm')]: {
        margin: "16px 7rem",
        marginBottom: '1px',
    },
    [theme.breakpoints.up('md')]: {
        margin: "16px 7rem",
        marginBottom: '1px',
        // maxHeight: isFullScreen == true ? "" : '80vh',
    },
    overflowY: 'auto !important',
    minHeight: '60vh',
}));

const LateralBox = styled(Box)(({ theme }) => ({
    background: "#f2f2f2",
    [theme.breakpoints.down("sm")]: {
        display: 'none'
    },
    [theme.breakpoints.up("sm")]: {
        display: 'block !important'
    },
}));

export const CustomMainContainer = props => {

    return (<ContainerPrincipal>
        <LateralBox />
        <RootStyle>
            {props.viewAppBar === false ? null :
                <CustomCounterAppBar viewMenu={props.viewMenu}
                    viewButtonClose={(props.viewButtonClose == null ||
                        props.viewButtonClose == undefined ? false : props.viewButtonClose)}
                    ActiveConfig={props.ActiveConfig}
                    closeClick={props.closeAction}
                    initialStep={props.initialStep}
                    endingStep={props.endingStep}
                />
            }
            {props.header != undefined && props.header != null ? props.header : null}
            <OutletWrapper>
                {props.headerWraper != undefined && props.headerWraper != null ? props.headerWraper : null}
                <OutletCenter isFullScreen={props.buttons === undefined || props.buttons === null ? true : false}>
                    {props.body}
                    {props.externals != undefined && props.externals != null ?
                        <Box sx={{
                            display: 'none',
                            height: '0px',
                            border: '0px',
                            padding: '0px',
                        }}>
                            {props.externals}
                        </Box>
                        : null
                    }
                </OutletCenter>
            </OutletWrapper>
            {props.buttons != undefined && props.buttons != null ?
                <Box sx={{
                    bottom: '20px',
                    position: 'sticky',
                    textAlign: 'center',
                    marginLeft: '24px',
                    marginRight: '24px',
                    flexDirection: 'column',
                    display: 'flex',
                    alignItems: 'center',
                    zIndex: 20,
                }}>
                    {props.buttons}
                </Box>
                : null}
        </RootStyle>
        <LateralBox />
    </ContainerPrincipal >)
}